import styled from 'styled-components';
import { Button } from '@material-ui/core';


export const Wrapper = styled.div`
  .export-data {
      margin-top: 20px;
      float: right;
      button {
        color: #6896c8;
      }
    }
  .align-right {
    text-align: right;
    padding: 0;
  }

  .is-new{
    align-items: flex-end;
  }

  .export {
    color: #6896c8;
    font-size: 12px;
  }

  font-size: .8em;
  .checkbox {
    padding: 0 0 0 22px;
  }

  .input-info-channel {
    width: 100%;
  }
  .add-button {
    padding-top: 18px;
  }
`;

export const PlanHeaderWrapper = styled.div`
  margin-bottom: 10px;
  text-transform: uppercase;
  font-weight: 500;
  margin-top: 20px;
`;

export const PlanRowWrapper = styled.div`
  padding: 2px 0;
  padding-top: 8px;
  padding-bottom: 8px;
  border-top: 1px solid #ccc;
  font-size: 15px;
`;

export const RedButton = styled(Button)`
  color: #e05959 !important;
`;
